import {IApplicationState} from '../../../../types/types';
import {getAuthUser} from './getAuthUser';

export const getAuthUserIsAttachmentViewTypeGrid = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);

    return typeof user.meta.isAttachmentViewTypeGrid === 'undefined' ? true : user.meta && user.meta.isAttachmentViewTypeGrid;
};
